import { AvatarWithLabel, AvatarLetter, TableBodyCell } from '@pocketlaw/tetris';
export function RequestedByCell(props) {
    const { requester } = props;
    return (<TableBodyCell headers="requestedByCell">
      <AvatarWithLabel size="md" title={requester}>
        <AvatarLetter>{requester[0]}</AvatarLetter>
      </AvatarWithLabel>
    </TableBodyCell>);
}
